<h2 mat-dialog-title>{{ 'CreateADirectory' | translate: {Default: "Create A Directory"} }}</h2>

<mat-dialog-content [formGroup]="form">
  
    <mat-form-field>
        <input 
            matInput
            [placeholder]="translate.instant('DirectoryName')"
            formControlName="directoryName">
    </mat-form-field>
 
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" class="submit-button" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" >{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>